// extracted by mini-css-extract-plugin
export default {"input":"NeoAcademyModuleInput_input__9l9CJ"};